import { differenceInMinutes } from 'date-fns/esm';
import React, { useMemo } from 'react';
import { EVisitItem } from 'types/e-visits';
import { EventItemSC } from './event-item.styled';
import { getTagColors } from '../../../../e-visits/e-visits.util';
import { useSelector } from 'react-redux';
import TStore from 'types/store';
import { grayscale } from 'polished';
import { getEventNameAndDate } from '../../../../utils';

interface EventItemProps {
  item: EVisitItem;
  onClick: () => void;
  dayView?: true;
}

const EventItem: React.FunctionComponent<EventItemProps> = ({ item, onClick, dayView }) => {
  const itemSpan = Math.abs(
    differenceInMinutes(new Date(item.event.from), new Date(item.event.to)),
  );

  const selectedTag = useSelector((state: TStore) => state.reservationForm.selectedTag);
  const activeEvent = useSelector((state: TStore) => state.reservationForm.event);

  const { backgroundColor, textColor } = useMemo(() => {
    let res = {
      backgroundColor: '#62AB81',
      textColor: '#62AB81',
    };

    // @ts-ignore
    if (activeEvent?.eventId === item.event?.eventId) {
      res.backgroundColor = grayscale(res.backgroundColor);
    }

    let tagColor = '';
    if (selectedTag && dayView && item.event.editing) {
      tagColor = selectedTag.color;
    } else {
      tagColor = item.order?.tag?.color || item.event.tag?.color || '';
    }

    if (tagColor) {
      res = getTagColors(tagColor);
    } else if (item.order) {
      res.textColor = 'white';
    }

    return res;
  }, [item, selectedTag, dayView, selectedTag, activeEvent]);

  const Paragraph = useMemo(() => {
    const { name, date } = getEventNameAndDate(item);

    if (itemSpan >= 30) {
      return (
        <>
          <div className="name">{name}</div>
          {date}
        </>
      );
    } else {
      return <div className="name">{name}</div>;
    }
  }, [item]);

  return (
    <EventItemSC
      ordered={item.order !== undefined}
      onClick={onClick}
      editing={item.event.editing}
      backgroundColor={backgroundColor}
      textColor={textColor}
    >
      <div className="content">{Paragraph}</div>
    </EventItemSC>
  );
};

export default React.memo<EventItemProps>(EventItem);
